import React from 'react'

const AddProducts = () => {
  return (
    <div>
      
    </div>
  )
}

export default AddProducts
